import GlobalStyles from '@mui/material/GlobalStyles';
import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Modal from '@mui/material/Modal';
import Divider from '@mui/material/Divider';
import ViewDocx from './ViewDocx'
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { useState, useEffect} from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Badge from '@mui/material/Badge';
import Paper from '@mui/material/Paper';
import { DataGrid, GridColDef, GridToolbar, gridDateComparator } from '@mui/x-data-grid';
import DocumentContextElement from './DocumentContextElement';
import ConfirmationDialog from './ConfirmationDialog'
import CaseUpdateForm from './CaseUpdateForm'
import Box from '@mui/material/Box';
import GridViewIcon from '@mui/icons-material/GridView';
import ListAltIcon from '@mui/icons-material/ListAlt';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import PreviewIcon from '@mui/icons-material/Preview';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import WysiwygIcon from '@mui/icons-material/Wysiwyg';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import PublishIcon from '@mui/icons-material/Publish';
import TaskIcon from '@mui/icons-material/Task';
import Alert from '@mui/material/Alert';
import RefreshIcon from '@mui/icons-material/Refresh';
import GenerateDocumentDetail from './GenerateDocumentDetail';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import Container from '@mui/material/Container';
import Fab from '@mui/material/Fab';
import JSONForm from './JSONForm';
import TransformerResultDetail from './TransformerResultDetail';
import AddIcon from '@mui/icons-material/Add';
import SectionHeader from './SectionHeader';
import PreprocessingResultDetail from './PreprocessingResultDetail';
import {  useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { HOST } from '../components/config';

function CaseFacts(props) {
  const [contextDocuments, setContextDocuments] = useState([]);
  const [contextDocumentTypes, setContextDocumentTypes] = useState([]);
  
  const [error, setError] = useState(null);
  
  const caseId = props.caseId

  const docIdFilter = props.docIdFilter || []

  const preview = props.preview || false 

  const [pendingDocumentToDeleteId, setPendingDocumentToDeleteId] = useState(null);
  const [caseDocuments, setCaseDocuments] = useState([]);
  const [isLoadingCaseDocuments, setIsLoadingCaseDocuments] = useState(true);
  const [assemblyCaseDocumentProcessingInfo, setAssemblyCaseDocumentProcessingInfo] = useState({});
  const [assemblyCaseDocumentTransformers, setAssemblyCaseDocumentTransformers] = useState({});
  const [assemblyCaseDocumentTransformersNeedRefresh, setAssemblyCaseDocumentTransformersNeedRefresh] = useState(true);
  const [previewUrl, setPreviewUrl] = useState(null); 
  const [previewType, setPreviewType] = useState(null); 
  
  const [generatePanelId, setGeneratePanelId] = useState(null); 
  
  const missingContextDocuments = contextDocumentTypes.filter((type) => contextDocuments.filter((doc) => doc.assembly_document_id == type.id).length == 0) 

  const [assemblyDocEditorId, setAssemblyDocEditorId] = useState(null); 
  const [assemblyDocEditorJson, setAssemblyDocEditorJson] = useState(null); 
  
  const [assemblyTransformerModalId, setAssemblyTransformerModalId] = useState(null); 
  
  const loadContextDocumentTypes = () => {
      try {
        fetch(HOST + '/api/assembly_documents/?tenant_id=1&is_context_document=true',
        {   
          "method": "GET",
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
          }
         })
        .then((res) => res.json())
        .then((json) => {
            setContextDocumentTypes(json)
       })
      } catch (err) {
        console.log(err);
      } finally {
      }
  }
  useEffect( () => {
    loadContextDocumentTypes()
  }, []);
  
  const fetchAssemblyCaseDocumentTransformerResults = async (assembly_case_document_id, assembly_transformer_id, label) => {
      try {
        const response = await fetch(HOST + '/api/assembly_transformer_results/?assembly_case_document_id=' + assembly_case_document_id  + '&assembly_transformer_id=' + assembly_transformer_id, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  

        });
        const json = await response.json()
        setAssemblyCaseDocumentProcessingInfo((prevState) => {
          var result = {'transformer_id': assembly_transformer_id, 'label': label, 'count_processed': 0, 'count_errored': 0, 'count_processing': 0, 'count_success': 0, 'total': 0, 'updated_at': null }
          json.map((item) => {
            if (item.status.includes('ERROR'))
              result['count_errored'] += 1
            else if (item.status == 'SUCCESS')
              result['count_success'] += 1
            else if (item.status == 'PROCESSING')
              result['count_processing'] +=1
            if (item.updated_at && (!result['updated_at'] || item.updated_at > result['updated_at']))
              result.updated_at = item.updated_at
            result['total'] += 1
          })
          const newEntry = result 
          return ({
          ...prevState,
          [[assembly_case_document_id, assembly_transformer_id]]: newEntry 
        })})
      } catch (err) {
        setError(err);
      }   
  }

  const fetchAssemblyCaseDocumentTransformerAndResults = async (assembly_case_document_id, assembly_document_id) => {
      try {
        if (assemblyCaseDocumentTransformers[assembly_case_document_id] && !assemblyCaseDocumentTransformersNeedRefresh)
          return
        const response = await fetch(HOST + '/api/assembly_transformers/?assembly_document_id=' + assembly_document_id, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
        });
        const json = await response.json()
        setAssemblyCaseDocumentTransformers((prevState) => ({
          ...prevState,
          [assembly_case_document_id]: json 
        }))
        json.map((item) => fetchAssemblyCaseDocumentTransformerResults(assembly_case_document_id, item.id, item.label) )
      } catch (err) {
        setError(err);
      }   
  }
  
  const fetchCaseDocumentTemplateJsonToEdit= async (case_doc_id) => {
    try {
      const response = await fetch(HOST + '/api/assembly_case_documents/' + case_doc_id + '/', {
        "headers" : { 
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
          },  
      });
      const json = await response.json()
      setAssemblyDocEditorJson(json.template_json)
      setAssemblyDocEditorId(case_doc_id)
    }
    catch (err) {
      setError(err)
    }
  }
 
  const getCaseDocumentInfo = (case_doc_id) => {
    const case_doc_result = caseDocuments.filter((doc) => doc.id == case_doc_id)[0]
    if (case_doc_result)
      return case_doc_result
    const case_facts_result = contextDocuments.filter((doc) => doc.id == case_doc_id)[0]
    return case_facts_result
  }

  const fetchCaseDocuments = async () => {
    setIsLoadingCaseDocuments(true);
    try {
      const response = fetch(HOST + '/api/assembly_case_documents/?case_id=' + caseId, {
        "headers" : { 
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
          }
      })
        .then((res) => res.json())
        .then((json) => {
          json = json.filter((item) => (docIdFilter.length == 0 || docIdFilter.includes(item.assembly_document_id)))
          const new_case_docs = json.filter((doc) => !doc.is_context_document)
          setCaseDocuments(new_case_docs);
          const new_context_docs = json.filter((doc) => doc.is_context_document)
          setContextDocuments(new_context_docs)
          json.map((doc) => fetchAssemblyCaseDocumentTransformerAndResults(doc.id, doc.assembly_document_id))
       })
      var json = await response.json()
    } catch (err) {
      setError(err);
    } finally {
      setIsLoadingCaseDocuments(false);
    }
  };
  
  useEffect(() => {
    fetchCaseDocuments();
  
    const intervalId = setInterval(() => { fetchCaseDocuments(); }, 30000); // Poll every 5 seconds
    
    return () => {
      clearInterval(intervalId); // Clear interval on unmount
    };

  }, [caseId]); 
  
  const handleUpdateCaseDocTemplateJson = async (case_doc_id, template_json) => {
      try {
        fetch(HOST + '/api/assembly_case_documents/' + case_doc_id + '/',
        {   
          "method": "PATCH",
          "headers" : { 
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'Content-Type': 'application/json'
            },  
          "body": JSON.stringify({ template_json: template_json }) 
         })
        .then((res) => res.json())
        .then((json) => {
          fetchCaseDocuments()
       })
      } catch (err) {
        console.log(err);
      } finally {
      }
  };

  const handleDocxPreview= async (assembly_case_document_id) => {
      try {
        const response = await fetch(HOST + '/api/assembly_case_documents/' + assembly_case_document_id, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
        });
        const json = await response.json()
        const download_url = json['download_url']
        setPreviewUrl(download_url)
        setPreviewType(json.generate_filetype)
      } catch (err) {
        setError(err);
      }   
    };
  const handleCaseDocDownload = async (assembly_case_document_id) => {
      try {
        const response = await fetch(HOST + '/api/assembly_case_documents/' + assembly_case_document_id, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
        });
        const json = await response.json()
        const download_url = json['download_url']
        if (download_url){
          window.open(download_url, '_blank')
        }
      } catch (err) {
        setError(err);
      }   
    };
  const handleDeleteCaseDoc = async (assembly_case_document_id) => {
      try {
        const response = await fetch(HOST + '/api/assembly_case_documents/' + assembly_case_document_id +'/', { 
            "method": "DELETE", 
            "headers" : { 
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + localStorage.getItem('token')
              },  
        });
        fetchCaseDocuments()
        setPendingDocumentToDeleteId(null)
      } catch (err) {
        setError(err);
      }   
    };
  const handleCaseDocGenerate = async (assembly_case_document_id) => {
      try {
        setGeneratePanelId(assembly_case_document_id)
        //const response = await fetch('http://127.0.0.1:8000/assembly_case_documents/' + assembly_case_document_id+'/generate/', { "method": "POST" });
        //fetchCaseDocuments()
      } catch (err) {
        setError(err);
      }   
  };

  const documentColumns: GridColDef[] = [
    {
      field: 'updated_at',
      headerName: 'Updated At',
      description: 'The date this document was originally created..',
      sortable: true,
      width: 90,
      type: 'datetime',
      valueFormatter: (d_s) => d_s.toLocaleString(),
      valueGetter: (value, row) => new Date(row.updated_at)
    },
    { field: 'name', headerName: 'Name', flex: 1 },
    /*{ 
      field: 'processing_status', 
      headerName: 'Preparation Status', 
      width: 200,
      renderCell: (params) => {
        const processingTransformers = assemblyCaseDocumentTransformers[params.row.id]
        if (!processingTransformers)
          return <></>
        const items = processingTransformers.map((transformer) => { 
          const item = assemblyCaseDocumentProcessingInfo[[params.row.id, transformer.id]]
          return item }).filter((item) => item)
        if (items.filter((item) => item.count_processing > 0).length) 
          return <Chip  className="chip-boxy" label={'Processing'} color="info" variant="" />
        else if(items.filter((item) => item.total == 0).length)
          return <Chip  className="chip-boxy" label={'Needs Review'} color="warning" variant="" />
        else if(items.filter((item) => item.count_success > 0).length)
          return <Chip  className="chip-boxy" label={'Prepared'} color="success" variant="" />
        else if(items.filter((item) => item.count_errored > 0).length)
          return <Chip  className="chip-boxy" label={'Errored'} color="error" variant="" />
        else if (items.length == 0)
          return <Chip  className="chip-boxy" label={'Prepared'} color="success" variant="" />
        else
          return <Chip  className="chip-boxy" label={'Needs Review'} color="warning" variant="" />
    }
    },*/
    ...(preview ? [] : [{ 
      field: 'gen_status', 
      headerName: 'Document Status', 
      width: 200,
      renderCell: (params) => params.row.generated_status == 'SUCCESS' ? 
        (<Chip label="Generated" color="success" className="chip-boxy"  variant="" />) : 
        params.row.generated_status == 'ERROR' ?  
        (<Chip label="Errored" color="error"  className="chip-boxy" variant="" />) :
        params.row.generated_status == 'GENERATING' ?
        (<Chip label='Generating' color="info"  className="chip-boxy" variant="" />)  :
        (<Chip label='None' color="seconary"  className="chip-boxy" variant="outlined" />) 

    }]),
  ];
  const factSetColumns: GridColDef[] = [
    {
      field: 'updated_at',
      headerName: 'Updated At',
      description: 'The date this fact set was updated.',
      sortable: true,
      width: 90,
      type: 'datetime',
      valueFormatter: (d_s) => d_s.toLocaleString(),
      valueGetter: (value, row) => new Date(row.updated_at)
    },
    { field: 'name', headerName: 'Name', flex: 1 },
    { 
      field: 'processing_status', 
      headerName: 'Status', 
      width: 120,
      renderCell: (params) => {
        const processingTransformers = assemblyCaseDocumentTransformers[params.row.id]
        if (!processingTransformers) return <></>
        const items = processingTransformers.map((transformer) => { 
          const item = assemblyCaseDocumentProcessingInfo[[params.row.id, transformer.id]]
          return item }).filter((item) => item)
        if (items.filter((item) => item.count_processing > 0).length) 
          return <Chip  className="chip-boxy" label={'Processing'} color="info" variant="" />
        else if(items.filter((item) => item.count_success > 0).length)
          return <Chip  className="chip-boxy" label={'Prepared'} color="success" variant="" />
        else if(items.filter((item) => item.count_errored > 0).length)
          return <Chip  className="chip-boxy" label={'Errored'} color="error" variant="" />
        else if(items.filter((item) => item.total == 0).length)
          return <Chip  className="chip-boxy" label={'Needs Review'} color="warning" variant="" />
        else if (items.length == 0)
          return <Chip  className="chip-boxy" label={'Prepared'} color="success" variant="" />
        else 
          return <Chip  className="chip-boxy" label={'Needs Review'} color="warning" variant="" />

        } 
    },
  ];
  const paginationModel = { page: 0, pageSize: 10 };

  const infoForContextDocId = (assembly_doc_id) => contextDocumentTypes.filter((doc) => doc.id == assembly_doc_id)[0] 

  const documentDeleteConfirmation = pendingDocumentToDeleteId  ? <ConfirmationDialog 
                                                        title="Confirm Document Deletion"
                                                        confirmButton="Delete"
                                                        message="Are you sure you want to delete this generated document and any resulting metadata? This cannot be undone."
                                                        onCancel={ () => setPendingDocumentToDeleteId(null)} 
                                                        onConfirm={ () => handleDeleteCaseDoc(pendingDocumentToDeleteId)} /> 
                                                    : ''
  const assemblyDocTitle = (getCaseDocumentInfo(assemblyDocEditorId) || {}).name
  const assemblyDocEditor = assemblyDocEditorJson && assemblyDocEditorId ? <JSONForm useFormDisplay={false} title={"Edit " + assemblyDocTitle} handleBack={() => { setAssemblyDocEditorId(null) } }handleOnSubmit={(info) => handleUpdateCaseDocTemplateJson(assemblyDocEditorId, info) || setAssemblyDocEditorId(null) } template_json={assemblyDocEditorJson} /> : ''
  const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  display:'block',
  overflow:'scroll',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  height: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
  const stylePreviewer = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  display:'block',
  overflow:'scroll',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  height: '90%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
  const docxPreviewer = <ViewDocx docUrl={previewUrl} docType={previewType}/>

  const getRowClassName = (params) => {
    if (!props.currentFile)
      return ''
    return params.id === props.currentFile.documentId ? 'highlighted-row' : '';
  };

return (
<>
    { previewUrl &&
      <Modal
        open={true}
        onClose={() => setPreviewUrl(null)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
      <Box sx={stylePreviewer}>
        <Typography id="modal-modal-title-preview-docx" variant="h6" component="h2">
          Preview 
        </Typography>
        {docxPreviewer}
      </Box>
      </Modal>
    }
    {generatePanelId &&
      <GenerateDocumentDetail showOutput={props.showOutput} transformers={assemblyCaseDocumentTransformers[generatePanelId]} results={assemblyCaseDocumentTransformers[generatePanelId].map((item) => assemblyCaseDocumentProcessingInfo[[generatePanelId, item.id]]).filter((x) => x)} onCancel={() => setGeneratePanelId(null)} assemblyCaseDocumentInfo={getCaseDocumentInfo(generatePanelId) } /> 
    }
    {assemblyTransformerModalId &&
      <TransformerResultDetail 
        assemblyTransformerId={assemblyTransformerModalId.transformerId} 
        assemblyCaseDocumentId={assemblyTransformerModalId.caseDocumentId} 
        caseDocumentInfo={getCaseDocumentInfo(assemblyTransformerModalId.caseDocumentId)}
        onCancel={() => setAssemblyTransformerModalId(null)}

        /> 
    }
    {assemblyDocEditor && 
      <Modal
        open={assemblyDocEditor && assemblyDocEditorId}
        onClose={() => setAssemblyDocEditorId(null)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
      <Box sx={style}>
        {assemblyDocEditor}
      </Box>
      </Modal>
    }
    {documentDeleteConfirmation} 
    {props.context && (docIdFilter.length == 0 || contextDocuments.length > 0) &&
      <DataGrid
        rows={contextDocuments}
        columns={factSetColumns}
        initialState={{ sorting: { sortModel: [ { field: "updated_at", sort: 'desc' }]}, columns: { columnVisibilityModel: { 'pre_processing': true}}, pagination: { paginationModel } }}
        pageSizeOptions={[10, 25, 50, 100]}
        disableColumnSelector
          getRowClassName={getRowClassName}
        slots={{ toolbar: GridToolbar }}
        onRowClick={(params, event, details) => { 
          props.setCurrentFile({ 
              type: 'case_doc', 
              info: params.row,
              documentId: params.row.id, 
              filename: params.row.name, 
              fileType: 'json',
              created_at: params.row.created_at
              } )
            event.stopPropagation()
          } 
        }
        disableColumnFilter
        disableDensitySelector
        disableRowSelectionOnClick
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            csvOptions: { disableToolbarButton: true },
          },
        }}
        sx={{ border: 0 }}
      />
    }
    {preview && props.context && contextDocuments.length ==0 &&
      <Box sx={{p:1}}>
        No relevant facts.
      </Box>
    }
    {preview && !props.context && caseDocuments.length ==0 &&
      <Box sx={{p:1}}>
        No relevant documents.
      </Box>
    }
    {!props.context && (docIdFilter.length == 0 || caseDocuments.length > 0) &&
      <DataGrid
        rows={caseDocuments}
        columns={documentColumns}
          getRowClassName={getRowClassName}
        initialState={{ sorting: { sortModel: [ { field: "updated_at", sort: 'desc' }]}, columns: { columnVisibilityModel: { 'pre_processing': true}}, pagination: { paginationModel } }}
        pageSizeOptions={[10, 25, 50, 100]}
        disableColumnSelector
        
        onRowClick={(params, event, details) => { 
          props.setCurrentFile({ 
              type: 'case_doc', 
              info: params.row,
              documentId: params.row.id, 
              filename: params.row.name, 
              fileType: params.row.generate_filetype,
              created_at: params.row.created_at
              } )
            event.stopPropagation()
          } 
        }
        slots={{ toolbar: GridToolbar }}
        disableColumnFilter
        disableRowSelectionOnClick
        disableDensitySelector
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            csvOptions: { disableToolbarButton: true },
          },
        }}
        sx={{ border: 0 }}
      />
    }

</>
);
}
export default CaseFacts;
